import React from 'react';
import { Link } from 'react-router-dom';
import siteLogo from '../../assets/img/site-logo.jpg';
import { ThemeSwitcher } from '../ThemeSwitcher/ThemeSwitcher';
import ThemeCustomizer from '../ThemeCustomizer/ThemeCustomizer';
import AccessibilityControls from '../AccessibilityControls/AccessibilityControls';

import classes from './header.module.css';

export const Header: React.FC = () => {
  return (
    <div className={classes.Root}>
      <div className={classes.Logo}>
        <Link to="/">
          <img src={siteLogo} alt="Site Logo" className={classes.Image} />
        </Link>
      </div>
      <div className={classes.SiteTitle}>
        Центр військово-патріотичного виховання та допризовної підготовки
        учнівської молоді Дніпровського району міста Запоріжжя
      </div>
      <div className={classes.ThemeControls}>
        <ThemeCustomizer />
        <ThemeSwitcher />
      </div>
      <AccessibilityControls />
    </div>
  );
};
